Shopify.theme.jsVideoCarousel = {
  _ytQueue: [],
  _ytLoading: false,

  init: function($section) {
    const settings = Shopify.theme.getSectionData($section) || {};
    const slides = $section.find('[data-carousel-slide]');

    $section.data('carousel-settings', settings);
    $section.data('carousel-index', 0);
    $section.data('carousel-players', []);

    $section.on('click.videoCarousel', '[data-carousel-prev]', function(event) {
      event.preventDefault();
      Shopify.theme.jsVideoCarousel.show($section, ($section.data('carousel-index') || 0) - 1, true);
    });

    $section.on('click.videoCarousel', '[data-carousel-next]', function(event) {
      event.preventDefault();
      Shopify.theme.jsVideoCarousel.show($section, ($section.data('carousel-index') || 0) + 1, true);
    });

    $section.on('click.videoCarousel', '[data-carousel-dot]', function(event) {
      event.preventDefault();
      Shopify.theme.jsVideoCarousel.show($section, Number($(this).attr('data-carousel-dot')), true);
    });

    $section.on('click.videoCarousel', '[data-preview-jump]', function(event) {
      event.preventDefault();
      Shopify.theme.jsVideoCarousel.show($section, Number($(this).attr('data-preview-jump')), true);
    });

    $section.on('click.videoCarousel', '[data-carousel-playback]', function(event) {
      event.preventDefault();
      const $button = $(this);
      const $slide = $section.find('[data-carousel-slide].is-active');
      const handle = $slide.data('playerHandle');
      if (!handle) return;

      if ($button.attr('data-state') === 'paused') {
        handle.play();
        Shopify.theme.jsVideoCarousel.syncPlaybackButton($section, 'playing');
      } else {
        handle.pause();
        Shopify.theme.jsVideoCarousel.syncPlaybackButton($section, 'paused');
      }
    });

    if (slides.length) {
      this.show($section, 0, !!settings.autoplay);
    }
  },

  parseUrl: function(url) {
    const value = (url || '').trim();
    const shorts = value.match(/\/shorts\/([a-zA-Z0-9_-]{6,})/);
    const watch = value.match(/[?&]v=([a-zA-Z0-9_-]{6,})/);
    const share = value.match(/youtu\.be\/([a-zA-Z0-9_-]{6,})/);
    const embed = value.match(/\/embed\/([a-zA-Z0-9_-]{6,})/);
    const vimeo = value.match(/vimeo\.com\/(?:video\/)?(\d+)/);

    if (shorts) return { id: shorts[1], type: 'youtube', short: true };
    if (watch) return { id: watch[1], type: 'youtube', short: false };
    if (share) return { id: share[1], type: 'youtube', short: false };
    if (embed) return { id: embed[1], type: 'youtube', short: false };
    if (vimeo) return { id: vimeo[1], type: 'vimeo', short: false };
    return { id: '', type: '', short: false };
  },

  isMobile: function() {
    return window.matchMedia('(max-width: 798px)').matches;
  },

  sourceFor: function($slide) {
    const desktop = this.parseUrl($slide.attr('data-desktop-url'));
    const mobile = this.parseUrl($slide.attr('data-mobile-url'));

    if (!desktop.id) {
      desktop.id = $slide.attr('data-desktop-id') || '';
      desktop.type = $slide.attr('data-desktop-type') || 'youtube';
    }
    if (!mobile.id) {
      mobile.id = $slide.attr('data-mobile-id') || '';
      mobile.type = $slide.attr('data-mobile-type') || 'youtube';
      mobile.short = $slide.attr('data-mobile-short') === 'true';
    }

    if (this.isMobile() && mobile.id) {
      return mobile;
    }

    return desktop.id ? desktop : { id: $slide.attr('data-desktop-id') || '', type: $slide.attr('data-desktop-type') || 'youtube', short: false };
  },

  loadYouTube: function(callback) {
    if (window.YT && window.YT.Player) {
      callback();
      return;
    }

    this._ytQueue.push(callback);
    if (this._ytLoading) return;
    this._ytLoading = true;

    const carousel = this;
    const previous = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function() {
      if (typeof previous === 'function') previous();
      carousel._ytLoading = false;
      const queue = carousel._ytQueue.splice(0);
      queue.forEach(function(fn) { fn(); });
    };

    if (!document.getElementById('youtube-iframe-api')) {
      const tag = document.createElement('script');
      tag.id = 'youtube-iframe-api';
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    }
  },

  createPlayer: function($section, $slide) {
    const existing = $slide.data('playerHandle');
    if (existing) return existing;

    const settings = $section.data('carousel-settings') || {};
    const source = this.sourceFor($slide);
    if (!source.id) return null;

    const embed = $slide.find('[data-video-element]').get(0);
    if (!embed) return null;

    const shouldAutoplay = !!settings.autoplay;
    const isMobileShort = this.isMobile() && !!source.short;
    $slide.find('.video-carousel__frame').toggleClass('video-carousel__frame--short', isMobileShort);

    const slides = $section.find('[data-carousel-slide]');
    const loopSingle = slides.length < 2 && !!settings.autoloop;
    const carousel = this;
    const handle = {
      ready: false,
      pendingPlay: false,
      player: null,
      type: source.type,
      pause: function() {
        this.pendingPlay = false;
        if (!this.player || !this.ready) return;
        if (this.type === 'vimeo') {
          this.player.contentWindow.postMessage(JSON.stringify({ method: 'pause' }), '*');
        } else if (typeof this.player.pauseVideo === 'function') {
          this.player.pauseVideo();
        }
      },
      play: function() {
        this.pendingPlay = true;
        if (!this.player || !this.ready) return;
        if (this.type === 'vimeo') {
          this.player.contentWindow.postMessage(JSON.stringify({ method: 'setVolume', value: 0 }), '*');
          this.player.contentWindow.postMessage(JSON.stringify({ method: 'play' }), '*');
        } else if (typeof this.player.playVideo === 'function') {
          this.player.mute();
          this.player.playVideo();
        }
      },
      destroy: function() {
        if (this.type === 'youtube' && this.player && typeof this.player.destroy === 'function') {
          this.player.destroy();
        }
        embed.innerHTML = '';
      }
    };

    $slide.data('playerHandle', handle);
    const players = $section.data('carousel-players') || [];
    players.push(handle);
    $section.data('carousel-players', players);

    if (source.type === 'vimeo') {
      const iframe = document.createElement('iframe');
      const query = [
        'autoplay=' + (shouldAutoplay ? '1' : '0'),
        'muted=1',
        'controls=0',
        'title=0',
        'byline=0',
        'portrait=0',
        'playsinline=1',
        'dnt=1',
        'loop=' + (loopSingle ? '1' : '0')
      ].join('&');
      iframe.src = 'https://player.vimeo.com/video/' + source.id + '?' + query;
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      iframe.setAttribute('title', 'Video');
      iframe.style.border = '0';
      embed.appendChild(iframe);
      handle.player = iframe;
      handle.ready = true;
      window.addEventListener('message', function(event) {
        if (!event.origin || event.origin.indexOf('vimeo.com') === -1) return;
        let data = event.data;
        if (typeof data === 'string') {
          try { data = JSON.parse(data); } catch (error) { return; }
        }
        if (data && data.event === 'timeupdate' && data.data) {
          handle.currentTime = data.data.seconds;
          handle.duration = data.data.duration;
        }
        if (data && data.event === 'ended' && slides.length > 1 && settings.advance_on_end !== false) {
          carousel.show($section, ($section.data('carousel-index') || 0) + 1, true);
        }
      });
      iframe.addEventListener('load', function() {
        iframe.contentWindow.postMessage(JSON.stringify({ method: 'addEventListener', value: 'timeupdate' }), '*');
      });
      return handle;
    }

    const holder = document.createElement('div');
    embed.appendChild(holder);

    this.loadYouTube(function() {
      if (!$slide.data('playerHandle')) return;
      const playerVars = {
        autoplay: shouldAutoplay ? 1 : 0,
        mute: 1,
        controls: 0,
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
        iv_load_policy: 3,
        playsinline: 1,
        disablekb: 1,
        fs: 0,
        cc_load_policy: 0,
        origin: window.location.origin
      };
      if (loopSingle) {
        playerVars.loop = 1;
        playerVars.playlist = source.id;
      }

      handle.player = new window.YT.Player(holder, {
        videoId: source.id,
        host: 'https://www.youtube-nocookie.com',
        playerVars: playerVars,
        events: {
          onReady: function() {
            handle.ready = true;
            $section.find('[data-carousel-poster]').hide();
            if (handle.pendingPlay || ($slide.hasClass('is-active') && shouldAutoplay)) {
              handle.play();
            }
          },
          onStateChange: function(event) {
            if (event.data === window.YT.PlayerState.PLAYING) {
              $section.find('[data-carousel-poster]').hide();
              carousel.syncPlaybackButton($section, 'playing');
            }
            if (event.data === window.YT.PlayerState.PAUSED || event.data === window.YT.PlayerState.ENDED) {
              carousel.syncPlaybackButton($section, 'paused');
            }
            if (event.data === window.YT.PlayerState.ENDED && slides.length > 1 && settings.advance_on_end !== false) {
              carousel.show($section, ($section.data('carousel-index') || 0) + 1, true);
            }
          }
        }
      });
    });

    return handle;
  },

  syncPlaybackButton: function($section, state) {
    const $button = $section.find('[data-carousel-playback]');
    const playing = state === 'playing';

    $button.attr('data-state', playing ? 'playing' : 'paused');
    $button.attr('aria-label', playing ? 'Pause' : 'Play');
    $button.find('.video-carousel__playback-label').text(playing ? 'PAUSE' : 'PLAY');
  },

  revealText: function($section, $slide) {
    const previous = $section.data('text-timer');
    if (previous) window.clearTimeout(previous);

    $section.find('[data-carousel-slide]').removeClass('is-text-visible').removeData('text-time');
    this.watchText($section, $slide);
  },

  playbackFor: function(handle) {
    if (!handle || !handle.ready) return null;

    if (handle.type === 'youtube' && handle.player && typeof handle.player.getDuration === 'function') {
      const duration = Number(handle.player.getDuration()) || 0;
      const current = Number(handle.player.getCurrentTime()) || 0;
      if (!duration) return null;
      return { current: current, duration: duration };
    }

    if (handle.type === 'vimeo' && handle.duration) {
      return {
        current: Number(handle.currentTime) || 0,
        duration: Number(handle.duration) || 0
      };
    }

    return null;
  },

  watchText: function($section, $slide) {
    const previous = $section.data('text-watch');
    if (previous) window.clearInterval(previous);

    const carousel = this;
    const timer = window.setInterval(function() {
      if (!$slide.hasClass('is-active')) {
        window.clearInterval(timer);
        return;
      }

      const playback = carousel.playbackFor($slide.data('playerHandle'));
      if (!playback) return;

      const delay = Number($slide.attr('data-text-delay')) || 0;
      const hideBefore = Number($slide.attr('data-text-hide')) || 0;
      const remaining = playback.duration - playback.current;
      const nearEnd = hideBefore > 0 && remaining <= hideBefore;

      if (nearEnd || playback.current < Math.max(0, delay - 0.75)) {
        $slide.removeClass('is-text-visible');
      } else if (playback.current >= delay) {
        $slide.addClass('is-text-visible');
      }
    }, 400);

    $section.data('text-watch', timer);
  },

  previewItem: function($slide, index) {
    const name = ($slide.attr('data-preview-name') || '').trim();
    const text = ($slide.attr('data-preview-text') || '').trim();
    const source = this.sourceFor($slide);
    const $button = $('<button type="button" class="video-carousel__preview-item"></button>');
    $button.attr('data-preview-jump', index);

    if (source.type === 'youtube' && source.id) {
      const $image = $('<img class="video-carousel__preview-thumb" alt="">');
      $image.attr('src', 'https://i.ytimg.com/vi/' + source.id + '/mqdefault.jpg');
      $button.append($image);
    } else {
      $button.append('<span class="video-carousel__preview-thumb"></span>');
    }

    const $copy = $('<span class="video-carousel__preview-copy"></span>');
    $copy.append($('<span class="video-carousel__preview-name"></span>').text(name || text));
    if (name && text) {
      $copy.append($('<span class="video-carousel__preview-line"></span>').text(text));
    }
    $button.append($copy);
    return $button;
  },

  fillPreviews: function($section) {
    const slides = $section.find('[data-carousel-slide]');
    const count = slides.length;
    if (count < 2) return;

    const current = $section.data('carousel-index') || 0;
    const $previous = $section.find('[data-carousel-preview="prev"]').empty();
    const $next = $section.find('[data-carousel-preview="next"]').empty();

    for (let step = 1; step < count; step++) {
      const nextIndex = (current + step) % count;
      const previousIndex = (current - step + count) % count;
      $next.append(this.previewItem(slides.eq(nextIndex), nextIndex));
      $previous.append(this.previewItem(slides.eq(previousIndex), previousIndex));
    }
  },

  show: function($section, index, andPlay) {
    const slides = $section.find('[data-carousel-slide]');
    const count = slides.length;
    if (!count) return;

    index = ((index % count) + count) % count;

    slides.each(function() {
      const handle = $(this).data('playerHandle');
      if (handle && typeof handle.pause === 'function') {
        handle.pause();
      }
    });

    slides.removeClass('is-active');
    const $slide = slides.eq(index).addClass('is-active');
    $section.data('carousel-index', index);
    this.revealText($section, $slide);
    this.fillPreviews($section);

    $section.find('[data-carousel-dot]').removeClass('is-active').eq(index).addClass('is-active');

    const handle = this.createPlayer($section, $slide);
    if (andPlay && handle) {
      handle.play();
    }
  },

  unload: function($section) {
    const players = $section.data('carousel-players') || [];
    players.forEach(function(handle) {
      if (handle && typeof handle.destroy === 'function') {
        handle.destroy();
      }
    });
    const textTimer = $section.data('text-timer');
    if (textTimer) window.clearTimeout(textTimer);
    const textWatch = $section.data('text-watch');
    if (textWatch) window.clearInterval(textWatch);
    $section.off('.videoCarousel');
    $section.removeData('carousel-players carousel-index carousel-settings text-timer text-watch');
  }
};
